/* eslint-disable no-unused-vars */
import logo from "../assets/logo.png";
import BlackLogo from "../assets/BlackLogo.png";
import kid from "../assets/kid.png";
import brick1 from "../assets/brick1.png";
import brick2 from "../assets/brick2.png";
import brick3 from "../assets/brick3.png";
import gear1 from "../assets/gear1.png";
import gear2 from "../assets/gear2.png";
import gear3 from "../assets/gear3.png";
import brick4 from "../assets/brick4.png";
import course1 from "../assets/course1.png";
import course2 from "../assets/course2.png";
import course3 from "../assets/course3.png";
import course4 from "../assets/course4.png";
import ceo from "../assets/ceo.png";
import mayada from "../assets/mayada.png";
import sherin from "../assets/sherin.png";
import salma from "../assets/salma.png";
import ashraf from "../assets/ashraf.png";
import chrissy from "../assets/chrissy.png";
import bg2 from "../assets/bg2.png";
import facebook from "../assets/facebook.svg";
import instagram from "../assets/instagram.svg";
import linkedin from "../assets/linkedin.svg";
import twitter from "../assets/twitter.svg";
import cable from "../assets/cable.png";
import sumaia from "../assets/sumaia.png";
import asset1 from "../assets/Asset 1.svg";
import asset2 from "../assets/asset 2.png";
import asset3 from "../assets/asset 3.png";
import asset4 from "../assets/asset 4.png";
import asset5 from "../assets/asset 5.png";
import pic1 from "../assets/webp/01.webp";
import pic2 from "../assets/webp/02.webp";
import pic3 from "../assets/webp/03.webp";
import pic4 from "../assets/webp/04.webp";
import pic5 from "../assets/webp/05.webp";
import pic6 from "../assets/webp/06.webp";
import pic7 from "../assets/webp/07.webp";
import pic8 from "../assets/webp/08.webp";
import pic9 from "../assets/webp/09.webp";
import pic10 from "../assets/webp/10.webp";
import pic11 from "../assets/webp/11.webp";

import pic12 from "../assets/webp/12.webp";
import pic13 from "../assets/webp/13.webp";
import pic14 from "../assets/webp/14.webp";
import pic15 from "../assets/webp/15.webp";
import pic16 from "../assets/webp/16.webp";
import pic17 from "../assets/webp/17.webp";
import pic18 from "../assets/webp/18.webp";
import pic19 from "../assets/webp/19.webp";
import pic20 from "../assets/webp/20.webp";
import pic21 from "../assets/webp/21.webp";
import pic22 from "../assets/webp/22.webp";
import pic23 from "../assets/webp/23.webp";
import pic24 from "../assets/webp/24.webp";
import pic25 from "../assets/webp/25.webp";
import pic26 from "../assets/webp/26.webp";
import pic27 from "../assets/webp/27.webp";
import pic28 from "../assets/webp/28.webp";
import pic29 from "../assets/webp/29.webp";
import pic30 from "../assets/webp/30.webp";
import pic31 from "../assets/webp/31.webp";
import pic32 from "../assets/webp/32.webp";
import pic33 from "../assets/webp/33.webp";
import pic34 from "../assets/webp/34.webp";
import pic35 from "../assets/webp/35.webp";
import pic36 from "../assets/webp/36.webp";
import pic37 from "../assets/webp/37.webp";
import pic38 from "../assets/webp/38.webp";
import pic39 from "../assets/webp/39.webp";
import pic40 from "../assets/webp/40.webp";
import pic41 from "../assets/webp/41.webp";
import pic42 from "../assets/webp/42.webp";
import pic43 from "../assets/webp/43.webp";
import pic44 from "../assets/webp/44.webp";
import pic45 from "../assets/webp/45.webp";
import pic46 from "../assets/webp/46.webp";
import pic47 from "../assets/webp/47.webp";
import pic48 from "../assets/webp/48.webp";
import pic49 from "../assets/webp/49.webp";
import pic50 from "../assets/webp/50.webp";
import pic51 from "../assets/webp/51.webp";
import pic52 from "../assets/webp/52.webp";
import pic53 from "../assets/webp/53.webp";
import pic54 from "../assets/webp/54.webp";
import pic55 from "../assets/webp/55.webp";
import pic56 from "../assets/webp/56.webp";
import pic57 from "../assets/webp/57.webp";
import pic58 from "../assets/webp/58.webp";
import pic59 from "../assets/webp/59.webp";
import pic60 from "../assets/webp/60.webp";
import pic61 from "../assets/webp/61.webp";
import pic62 from "../assets/webp/62.webp";
import pic63 from "../assets/webp/63.webp";
import pic64 from "../assets/webp/64.webp";
import pic65 from "../assets/webp/65.webp";
import pic66 from "../assets/webp/66.webp";
import pic67 from "../assets/webp/67.webp";
import pic68 from "../assets/webp/68.webp";
import pic69 from "../assets/webp/69.webp";
import pic70 from "../assets/webp/70.webp";
import pic71 from "../assets/webp/71.webp";
import pic73 from "../assets/webp/73.webp";
import pic72 from "../assets/webp/72.webp";
import mariam from "../assets/mariam.png";
export default {
  mariam,
  asset1,
  asset2,
  asset3,
  asset4,
  asset5,
  pic1,
  pic2,
  pic3,
  pic4,
  pic5,
  pic6,
  pic7,
  pic8,
  pic9,
  pic10,
  pic11,
  pic12,
  pic13,
  pic14,
  pic15,
  pic16,
  pic17,
  pic18,
  pic19,
  pic20,
  pic21,
  pic22,
  pic23,
  pic24,
  pic25,
  pic26,
  pic27,
  pic28,
  pic29,
  pic30,
  pic31,
  pic32,
  pic33,
  pic34,
  pic35,
  pic36,
  pic37,
  pic38,
  pic39,
  pic40,
  pic41,
  pic42,
  pic43,
  pic44,
  pic45,
  pic46,
  pic47,
  pic48,
  pic49,
  pic50,
  pic51,
  pic52,
  pic53,
  pic54,
  pic55,
  pic56,
  pic57,
  pic58,
  pic59,
  pic60,
  pic61,
  pic62,
  pic63,
  pic64,
  pic65,
  pic66,
  pic67,
  pic68,
  pic69,
  pic70,
  pic71,
  pic73,
  pic72,
  cable,
  sumaia,
  linkedin,
  twitter,
  instagram,
  facebook,
  chrissy,
  ashraf,
  salma,
  sherin,
  mayada,
  ceo,
  bg2,
  course4,
  logo,
  BlackLogo,
  kid,
  brick1,
  brick2,
  brick3,
  brick4,
  gear1,
  gear2,
  gear3,
  course1,
  course2,
  course3,
};
